import styled from 'styled-components';

export const CellContent = styled.div.attrs<{ className?: string }>({ className: 'table-cell-content' })`
  margin: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .text-858dbd {
    color: var(--color-text-muted);
  }
`;
